import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { Marquee } from "@/components/landing/Marquee";
import { Guarantees } from "@/components/landing/Guarantees";
import { Services } from "@/components/landing/Services";
import { Process } from "@/components/landing/Process";
import { LeadSection } from "@/components/landing/LeadSection";
import { Faq } from "@/components/landing/Faq";
import { Footer } from "@/components/landing/Footer";
import { MobileBar } from "@/components/landing/MobileBar";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = undefined; };
  }, []);

  return (
    <div className="min-h-screen bg-[var(--ivory)] pb-20 md:pb-0">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Guarantees />
        <Services />
        <Process />
        <LeadSection />
        <Faq />
      </main>
      <Footer />
      <MobileBar />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
